// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --white: #fff;
  --primary: #5541d7;
  --primary-70: #2a23c2;
  --primary-30: #766eda;
  --primary-10: #dbd7f4;
  --button-hover: #4434af;
  --basic-button-hover: #eeeff7;
  --grey: #7f7f7f;
  --grey-text: #9a9ab0;
  --grey-text-second: #92929d;
  --grey-icon: #4c4c4c;
  --grey-border: #e1e1e1;
  --grey-secondary: #DBE2F9;
  --light-grey: #e0e0e0;
  --red: #ba3a3a;
  --red-bg: #fdebeb;
  --red-hover: #d14b4b;
  --red-active: #8c2a2a;
  --red-disable: #afafaf;
  --red-light: #fdebeb;
  --black: #120f39;
  --bg: #f7f7fc;
  --chart-purple: #512ca0;
  --chart-grey: #e2e2ea;
  --pist: #E3EFE8;
  --green: #378b59;
  --green-button: #31c67e;
  --green-button-hover: #2aa96c;
  --green-button-active: #ade8cb;
  --grey-variable: #e0e0e059;
  --grey-variable-hover: #e2e2ea;
  --orange: #d9790c;
  --orange-secondary: #f9d48d;
  --orange-light-secondary: #fef7e8;
  --orange-light: #fff4dc;
  --icon-primary-color: var(--grey-icon);
  --fill-progress-color: #cae4db;
  --bg-progress-color: var(--chart-grey);
  --unfill-progress-color: var(--bg-progress-color);
  --span-text-color: var(--primary);
  --box-shadow: 0 2px 3px rgba(227, 225, 240, 0.5);
  --card-border-color: var(--grey-border);
  --header-border-color: #e1e3eb;
  --element-shadow: 0 1.6rem 1.6rem rgba(97, 97, 97, 0.1), 0 0.8rem 1.6rem rgba(97, 97, 97, 0.1);
  --chart-progress-secondary: var(--grey-secondary);
  --chart-som: #181485;
  --chart-sam: #5541D7;
  --chart-tam: #9A9AB0;
  --chart-pam: #F7F7FC;
  --radio-border: var(--grey-border);
  --radio-main: var(--white);
  --chips-bg: var(--grey-variable);
  --chips-bg-hover: var(--grey-variable-hover);
  --chips-border-hover: inherit;
  --chips-text-hover: inherit;
  --element-hover: var(--bg);
  --element-row-border: var(--grey-secondary);
  --comment-block: #f4f4f4;
  --table-header: #ededfd;
  --side-menu-border: var(--grey-border);
  --side-menu-shadow: 0px 6px 20px rgba(24, 20, 51, 0.1), -8px 0px 16px rgba(97, 97, 97, 0.1);
  --side-menu-divider: var(--grey-border);
  --font-family: "Roboto", sans-serif;
  --font-family-second: "Mulish", sans-serif;
  --primary-20: #22293A;
  --primary-60: #141B25;
  --text-40: #8990A5;
  --text-70: #BFC6DC;
  --txt-100: #120F39;
  --shadow-30: #1F2431;
  --section-bg-helper: #e1e1fb;
}

.app-form-field {
  display: block;
  position: relative;
}
.app-form-field .label {
  font-size: 1.4rem;
  line-height: 1.8rem;
  font-weight: 500;
  color: var(--black);
  margin-bottom: 0.8rem;
}
.app-form-field .label > app-label {
  display: flex;
  align-items: center;
  gap: 1rem;
}
.app-form-field .wrapper {
  height: 4.8rem;
  background: var(--white);
  padding: 0 1rem;
  border: 0.1rem solid var(--white);
  border-radius: 0.8rem;
  display: flex;
  align-items: center;
  transition: border-color 0.2s;
  position: relative;
}
.app-form-field .prefix {
  margin-right: 1rem;
}
.app-form-field .infix {
  height: 100%;
  flex-grow: 1;
  display: flex;
  align-items: center;
}
.app-form-field .suffix {
  font-size: 1.8rem;
  margin-left: 1rem;
  display: flex;
  align-items: center;
}
.app-form-field.border .wrapper {
  border-color: var(--primary-10);
}
.app-form-field.input, .app-form-field.textarea {
  cursor: text;
}
.app-form-field.input .wrapper, .app-form-field.textarea .wrapper {
  height: auto;
}
.app-form-field.textarea .wrapper {
  padding: 2rem;
}
.app-form-field.select .wrapper {
  padding: 0;
}
.app-form-field.filled .wrapper {
  border-color: var(--primary-10);
}
.app-form-field:hover .wrapper, .app-form-field.focused .wrapper {
  border-color: var(--primary-30);
}
.app-form-field .warn:not(:empty) {
  height: 1.4rem;
  font-size: 1.2rem;
  line-height: 1.4rem;
  color: var(--orange);
  margin-top: 0.8rem;
}
.app-form-field.warn .wrapper {
  border-color: var(--orange-secondary);
  background-color: var(--orange-light-secondary);
}
.app-form-field .error:not(:empty) {
  height: 1.4rem;
  font-size: 1.2rem;
  line-height: 1.4rem;
  color: var(--red);
  margin-top: 0.8rem;
}
.app-form-field.error .wrapper {
  border-color: var(--red);
  background-color: var(--red-bg);
}
.app-form-field .eye {
  font-size: 1.8rem;
  color: var(--grey-text);
  display: grid;
  align-items: center;
}
.app-form-field.disabled .wrapper {
  border: 0.1rem solid #f4f4f4 !important;
}
.app-form-field.disabled .wrapper input {
  color: #e0e0e0 !important;
  pointer-events: none;
}

.sub-label {
  font-weight: 400;
  height: 1.4rem;
  color: var(--black) !important;
  font-size: 1.2rem;
  line-height: 1.4rem;
  margin-top: 0.8rem;
}

.btn-action {
  margin-left: -0.8rem;
  font-size: 1.5rem;
  color: var(--grey-icon);
  width: 2.4rem;
  height: 2.4rem;
  border-radius: 0.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.2s;
}
.btn-action:hover {
  color: var(--primary);
  background: rgba(226, 225, 249, 0.33);
}
.btn-action:active {
  color: var(--primary);
  background: rgba(226, 225, 249, 0.33);
}`, "",{"version":3,"sources":["webpack://./src/styles/variables.scss","webpack://./src/shared/form-field/form-field.component.scss","webpack://./src/styles/mixins.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,uBAAA;EACA,6BAAA;EACA,eAAA;EACA,oBAAA;EACA,2BAAA;EACA,oBAAA;EACA,sBAAA;EACA,yBAAA;EACA,qBAAA;EACA,cAAA;EACA,iBAAA;EACA,oBAAA;EACA,qBAAA;EACA,sBAAA;EACA,oBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,6BAAA;EACA,8BAAA;EACA,0BAAA;EACA,8BAAA;EACA,iBAAA;EACA,2BAAA;EACA,iCAAA;EACA,uBAAA;EAEA,sCAAA;EACA,8BAAA;EACA,sCAAA;EACA,iDAAA;EACA,iCAAA;EACA,gDAAA;EACA,uCAAA;EACA,8BAAA;EACA,8FAAA;EACA,iDAAA;EAEA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EAEA,kCAAA;EACA,0BAAA;EAEA,gCAAA;EACA,4CAAA;EACA,6BAAA;EACA,2BAAA;EAEA,0BAAA;EACA,2CAAA;EAEA,wBAAA;EAEA,uBAAA;EAEA,sCAAA;EACA,2FAAA;EACA,uCAAA;EAEA,mCAAA;EACA,0CAAA;EAEA,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,oBAAA;EACA,4BAAA;ACTF;;AArEA;EACE,cAAA;EACA,kBAAA;AAwEF;AAtEE;ECSA,iBAAA;EACA,mBAAA;EACA,gBAAA;EDTE,mBAAA;EACA,qBAAA;AA0EJ;AAxEI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AA0EN;AA/DE;EACE,cAAA;EACA,wBAAA;EACA,eAAA;EACA,iCAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,kBAAA;AAiEJ;AA9DE;EACE,kBAAA;AAgEJ;AA7DE;EACE,YAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AA+DJ;AA5DE;EACE,iBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;AA8DJ;AA1DI;EACE,+BAAA;AA4DN;AAxDE;EAEE,YAAA;AAyDJ;AAvDI;EACE,YAAA;AAyDN;AApDI;EACE,aAAA;AAsDN;AAjDI;EACE,UAAA;AAmDN;AA9CI;EACE,+BAAA;AAgDN;AA1CI;EACE,+BAAA;AA4CN;AAxCE;EACE,cAAA;EC3FF,iBAAA;EACA,mBAAA;ED4FE,oBAAA;EACA,kBAAA;AA2CJ;AAvCI;EACE,qCAAA;EACA,+CAAA;AAyCN;AArCE;EACE,cAAA;ECzGF,iBAAA;EACA,mBAAA;ED0GE,iBAAA;EACA,kBAAA;AAwCJ;AApCI;EACE,wBAAA;EACA,+BAAA;AAsCN;AAxBE;EACE,iBAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;AA0BJ;AAtBI;EACE,uCAAA;AAwBN;AAtBM;EACE,yBAAA;EACA,oBAAA;AAwBR;;AAlBA;EACE,gBAAA;EACA,cAAA;EACA,8BAAA;ECtJA,iBAAA;EACA,mBAAA;EDuJA,kBAAA;AAsBF;;AAnBA;EACE,oBAAA;EACA,iBAAA;EACA,uBAAA;EACA,aAAA;EACA,cAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAsBF;AApBE;EACE,qBAAA;EACA,qCAAA;AAsBJ;AAnBE;EACE,qBAAA;EACA,qCAAA;AAqBJ","sourcesContent":[":root {\n  --white: #fff;\n  --primary: #5541d7;\n  --primary-70: #2a23c2;\n  --primary-30: #766eda;\n  --primary-10: #dbd7f4;\n  --button-hover: #4434af;\n  --basic-button-hover: #eeeff7;\n  --grey: #7f7f7f;\n  --grey-text: #9a9ab0;\n  --grey-text-second: #92929d;\n  --grey-icon: #4c4c4c;\n  --grey-border: #e1e1e1;\n  --grey-secondary: #DBE2F9;\n  --light-grey: #e0e0e0;\n  --red: #ba3a3a;\n  --red-bg: #fdebeb;\n  --red-hover: #d14b4b;\n  --red-active: #8c2a2a;\n  --red-disable: #afafaf;\n  --red-light: #fdebeb;\n  --black: #120f39;\n  --bg: #f7f7fc;\n  --chart-purple: #512ca0;\n  --chart-grey: #e2e2ea;\n  --pist: #E3EFE8;\n  --green: #378b59;\n  --green-button: #31c67e;\n  --green-button-hover: #2aa96c;\n  --green-button-active: #ade8cb;\n  --grey-variable: #e0e0e059;\n  --grey-variable-hover: #e2e2ea;\n  --orange: #d9790c;\n  --orange-secondary: #f9d48d;\n  --orange-light-secondary: #fef7e8;\n  --orange-light: #fff4dc;\n\n  --icon-primary-color: var(--grey-icon);\n  --fill-progress-color: #cae4db;\n  --bg-progress-color: var(--chart-grey);\n  --unfill-progress-color: var(--bg-progress-color);\n  --span-text-color: var(--primary);\n  --box-shadow: 0 2px 3px rgba(227, 225, 240, 0.5);\n  --card-border-color: var(--grey-border);\n  --header-border-color: #e1e3eb;\n  --element-shadow: 0 1.6rem 1.6rem rgba(97, 97, 97, 0.1), 0 0.8rem 1.6rem rgba(97, 97, 97, 0.1);\n  --chart-progress-secondary: var(--grey-secondary);\n\n  --chart-som: #181485;\n  --chart-sam: #5541D7;\n  --chart-tam: #9A9AB0;\n  --chart-pam: #F7F7FC;\n\n  --radio-border: var(--grey-border);\n  --radio-main: var(--white);\n\n  --chips-bg: var(--grey-variable);\n  --chips-bg-hover: var(--grey-variable-hover);\n  --chips-border-hover: inherit;\n  --chips-text-hover: inherit;\n\n  --element-hover: var(--bg);\n  --element-row-border: var(--grey-secondary);\n\n  --comment-block: #f4f4f4;\n\n  --table-header: #ededfd;\n\n  --side-menu-border: var(--grey-border);\n  --side-menu-shadow: 0px 6px 20px rgba(24, 20, 51, 0.1), -8px 0px 16px rgba(97, 97, 97, 0.1);\n  --side-menu-divider: var(--grey-border);\n\n  --font-family: 'Roboto', sans-serif;\n  --font-family-second: 'Mulish', sans-serif;\n\n  --primary-20: #22293A;\n  --primary-60: #141B25;\n  --text-40: #8990A5;\n  --text-70: #BFC6DC;\n  --txt-100: #120F39;\n  --shadow-30: #1F2431;\n  --section-bg-helper: #e1e1fb;\n}","@import 'src/styles/mixins';\n@import 'src/styles/variables';\n\n.app-form-field {\n  display: block;\n  position: relative;\n\n  & .label {\n    @include label;\n    color: var(--black);\n    margin-bottom: 0.8rem;\n\n    & > app-label {\n      display: flex;\n      align-items: center;\n      gap: 1rem;\n    }\n  }\n\n  // &.sub-label {\n  //   font-weight: 400;\n  //   height: 1.4rem;\n  //   @include button-medium-text;\n  //   margin-top: .8rem;\n  // }\n\n  & .wrapper {\n    height: 4.8rem;\n    background: var(--white);\n    padding: 0 1rem;\n    border: 0.1rem solid var(--white);\n    border-radius: 0.8rem;\n    display: flex;\n    align-items: center;\n    transition: border-color 0.2s;\n    position: relative;\n  }\n\n  & .prefix {\n    margin-right: 1rem;\n  }\n\n  & .infix {\n    height: 100%;\n    flex-grow: 1;\n    display: flex;\n    align-items: center;\n  }\n\n  & .suffix {\n    font-size: 1.8rem;\n    margin-left: 1rem;\n    display: flex;\n    align-items: center;\n  }\n\n  &.border {\n    & .wrapper {\n      border-color: var(--primary-10);\n    }\n  }\n\n  &.input,\n  &.textarea {\n    cursor: text;\n\n    & .wrapper {\n      height: auto;\n    }\n  }\n\n  &.textarea {\n    & .wrapper {\n      padding: 2rem;\n    }\n  }\n\n  &.select {\n    & .wrapper {\n      padding: 0;\n    }\n  }\n\n  &.filled {\n    & .wrapper {\n      border-color: var(--primary-10);\n    }\n  }\n\n  &:hover,\n  &.focused {\n    & .wrapper {\n      border-color: var(--primary-30);\n    }\n  }\n\n  & .warn:not(:empty) {\n    height: 1.4rem;\n    @include button-medium-text;\n    color: var(--orange);\n    margin-top: 0.8rem;\n  }\n\n  &.warn {\n    & .wrapper {\n      border-color: var(--orange-secondary);\n      background-color: var(--orange-light-secondary);\n    }\n  }\n\n  & .error:not(:empty) {\n    height: 1.4rem;\n    @include button-medium-text;\n    color: var(--red);\n    margin-top: 0.8rem;\n  }\n\n  &.error {\n    & .wrapper {\n      border-color: var(--red);\n      background-color: var(--red-bg);\n    }\n  }\n\n  & .error {\n    // &.sub-label {\n    //   font-weight: 400;\n    //   height: 1.4rem;\n    //   color: var(--black) !important;\n    //   @include button-medium-text;\n    //   margin-top: .8rem;\n    // }\n  }\n\n  & .eye {\n    font-size: 1.8rem;\n    color: var(--grey-text);\n    display: grid;\n    align-items: center;\n  }\n\n  &.disabled {\n    & .wrapper {\n      border: 0.1rem solid #f4f4f4 !important;\n\n      & input {\n        color: #e0e0e0 !important;\n        pointer-events: none;\n      }\n    }\n  }\n}\n\n.sub-label {\n  font-weight: 400;\n  height: 1.4rem;\n  color: var(--black) !important;\n  @include button-medium-text;\n  margin-top: 0.8rem;\n}\n\n.btn-action {\n  margin-left: -0.8rem;\n  font-size: 1.5rem;\n  color: var(--grey-icon);\n  width: 2.4rem;\n  height: 2.4rem;\n  border-radius: 0.4rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: 0.2s;\n\n  &:hover {\n    color: var(--primary);\n    background: rgba(226, 225, 249, 0.33);\n  }\n\n  &:active {\n    color: var(--primary);\n    background: rgba(226, 225, 249, 0.33);\n  }\n}\n","@mixin button-text {\n  font-size: 1.6rem;\n  line-height: 1.9rem;\n}\n\n@mixin button-medium-text {\n  font-size: 1.2rem;\n  line-height: 1.4rem;\n}\n\n@mixin small-button-text {\n  font-size: 1.4rem;\n  line-height: 1.7rem;\n}\n\n@mixin label {\n  font-size: 1.4rem;\n  line-height: 1.8rem;\n  font-weight: 500;\n}\n\n@mixin full {\n  &.full {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
